import React from 'react';

const AppContext = React.createContext<any>({
	translation: [],
	globalTemplate: 'default',
});

interface AppContextUserData {
	id: string;
	workplaceId: string;
}

interface AppContextProps {
	socketUrl: string;
	userData: AppContextUserData;
	apiUrl: string;
	accessToken: string;
	language: string;
	currency: string;
	vatRate: string;
	loggedUserId: string;
	workplaceId: string;
	globalTemplate: string;
	translation: { [key: string]: string };
	dateFormat: string;
	dateFormatMoment: string;
	isLatam: boolean;
	isKdar: boolean;
	phonePrefix: string;
	meddiCreditsMinimumBuyIn: number;
	socket: {
		on: (event: string, callback: (data: any) => void) => void;
		off: (event: string, callback: (data: any) => void) => void;
	};
	children: React.ReactNode;
	partnerId: number;
}

export const AppContextProvider = (props: AppContextProps) => {
	// @ts-ignore
	let dateFormat = MeddiApp.dateFormat;
	if (dateFormat === 'd.m.Y') {
		dateFormat = 'dd.MM.yyyy';
	}

	let dateFormatMoment = 'DD.MM.YYYY';
	let isLatam = false;
	// @ts-ignore
	switch (MeddiApp.globalTemplate) {
		case 'peru':
		case 'ecuador':
		case 'mexico':
		case 'colombia':
			isLatam = true;
			dateFormatMoment = 'DD/MM/YYYY';
	}

	// @ts-ignore
	return (
		<AppContext.Provider
			value={{
				...props,
				// @ts-ignore
				socketUrl: MeddiApp.socketUrl,
				// @ts-ignore
				userData: MeddiApp.userData,
				// @ts-ignore
				apiUrl: MeddiApp.socketUrl,
				// @ts-ignore
				accessToken: MeddiApp.accessToken,
				// @ts-ignore
				language: MeddiApp.language,
				// @ts-ignore
				dateFormat: dateFormat,
				// @ts-ignore
				currency: MeddiApp.currency,
				// @ts-ignore
				vatRate: MeddiApp.vatRate,
				// @ts-ignore
				loggedUserId: MeddiApp.loggedUserId,
				// @ts-ignore
				phonePrefix: MeddiApp.phonePrefix,
				// @ts-ignore
				translation: jsTranslation,
				isLatam,
				dateFormatMoment,
				// @ts-ignore
				socket: MeddiApp.actualCase.socket,
				// @ts-ignore
				partnerId: MeddiApp.partnerId,
				// @ts-ignore
				meddiCreditsMinimumBuyIn: MeddiApp.meddiCreditsMinimumBuyIn,
				// @ts-ignore
				isKdar: MeddiApp.isKdar,
			}}
		>
			{props.children}
		</AppContext.Provider>
	);
};

export const useAppContext = (): AppContextProps =>
	React.useContext(AppContext);
